'use strict'

import React    from 'react'
import ReactDOM from 'react-dom'
import Slider   from 'react-slider'

export default class Calculator extends React.Component {
  constructor () {
    super()

    this.state = {
      totals: [1000, 2000, 3000, 4000, 5000, 10000],
      weeks: [19, 39],
      amounts: [49, 59, 79, 99, 150],
      amountValue: 0,
      weeksValue: 0,
      saving: '$69 (7%)'
    }

    this.weeks = [
      [19, 39],
      [16, 32, 47],
      [12, 24, 35, 46],
      [9, 18, 27, 36, 45],
      [60]
    ]

    this.totals = [
      [1000, 2000],
      [1000, 2000, 3000],
      [1000, 2000, 3000, 4000],
      [1000, 2000, 3000, 4000, 5000],
      [10000]
    ]

    this.savings = [
      ['$69 (7%)',
       '$89 (4%)'],
      ['$56 (6%)',
       '$112 (6%)',
       '$227 (8%)'],
      ['$52 (5%)',
       '$104 (5%)',
       '$235 (8%)',
       '$366 (9%)'],
      ['$100 (10%)',
       '$200 (10%)',
       '$300 (10%)',
       '$400 (10%)',
       '$500 (10%)'],
      ['$1000 (10%)']
    ]
  }

  getParam (name) {
    let query = window.location.search.substring(1)
    let vars = query.split('&')

    for (let i in vars) {
      let pair = vars[i].split('=')
      if (pair[0] === name) {
        return pair[1]
      }
    }

    return false
  }

  update () {
    this.props.onChange('dental-package', {
      displayName: 'Package',
      value: ('$' + this.state.totals[this.refs.total.value]).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      weeklyPayment: '$' + this.state.amounts[this.refs.amount.getValue()],
      weeks: this.state.weeks[this.state.weeksValue],
      savings: this.state.saving,
      fortnightlyPayment: '$' + this.state.amounts[this.refs.amount.getValue()] * 2,
      pageRef: 'calculator',
      order: 7,
      displayInSummary: true
    })
  }

  updateBars () {
    this.refs.amountValue.innerHTML = '$' + this.state.amounts[this.refs.amount.getValue()]
    this.refs.amountbar.style.width = parseInt(ReactDOM.findDOMNode(this.refs.amount).childNodes[0].style.left) + 15 + 'px'
  }

  amountSlider (e) {
    let index = this.refs.amount.getValue()

    this.setState({
      weeks: this.weeks[index].slice(0),
      amountValue: index,
      weeksValue: Math.min(this.weeks[index].length - 1, this.state.weeksValue),
      saving: this.savings[index][Math.min(this.weeks[index].length - 1, this.state.weeksValue)]
    }, () => {
      this.refs.total.value = this.weeks[index].length < 2 ? this.state.totals.length - 1 : this.state.weeksValue
      this.updateBars()
      this.update()
    })
  }

  weeksSelect (i) {
    if (i === this.state.weeksValue ||
        this.state.weeks.length - 1 < i) return

    let weeks = this.state.weeks[i]

    this.refs.total.value = weeks.length < 2 ? this.state.totals.length - 1 : i

    this.setState({
      weeksValue: i,
      saving: this.savings[this.refs.amount.getValue()][i]
    }, () => {
      this.updateBars()
      this.update()
    })
  }

  totalSelect (e) {
    let index = this.refs.total.value
    let total = this.state.totals[index]

    while (this.totals[this.state.amountValue] && this.totals[this.state.amountValue].indexOf(total) < 0) {
      this.state.amountValue = (this.state.amountValue + 1) % this.state.amounts.length
    }

    let amount = total === 10000
      ? this.state.amounts.length - 1
      : this.state.amountValue

    this.setState({
      weeks: this.weeks[amount].slice(0),
      weeksValue: Math.min(this.weeks[amount].length - 1, index),
      amountValue: amount,
      saving: this.savings[amount][Math.min(this.weeks[amount].length - 1, index)]
    }, () => {
      this.updateBars()
      this.update()
    })
  }

  componentDidMount () {
    let amountParam = this.state.amounts.indexOf(parseInt(this.getParam('amount')))
    let packageParam = parseInt(this.getParam('package'))
    let amountProp = this.state.amounts.indexOf(this.props.amount)
    let packageProp = this.props.package

    amountProp = amountProp > 0 ? amountProp : 0
    packageProp = packageProp > 0 ? packageProp : 0

    this.setState({
      amountValue: amountProp || amountParam || 0,
      weeksValue: packageProp || packageParam || 0,
      weeks: this.weeks[amountProp].slice(0)
    }, () => {
      this.refs.total.value = this.props.package || 0
      this.amountSlider()
      this.update()
      setTimeout(() => {
        this.updateBars()
      }, 100)
    })
  }

  start (e) {
    e.preventDefault()

    if (this.props.onStart) {
      this.props.onStart()
    }

    if (this.props.showForm) {
      window.calculatorClick = true
      this.props.showForm()
    }
  }

  render () {
    let len = this.state.weeks.length
    this.state.weeks.length = 5
    this.state.weeks.fill(null, len)

    const { className = '' } = this.props;

    return (
      <div className={`box calculator ${className}`}>
        {!this.props.hideTitle && <h2>Choose Weekly Amount and Term</h2>}
        <Slider
          ref='amount'
          onChange={this.amountSlider.bind(this)}
          max={this.state.amounts.length - 1}
          value={this.state.amountValue}>
          <div className='calculator-handle'>
            <div ref='amountValue' className='calculator-label'></div>
          </div>
        </Slider>
        <span ref='amountbar' className='calculator-bar'></span>
        <div className='calculator-scale'>
          <span ref='amountmin'>
            {'$' + this.state.amounts[0]}
          </span>
          <span ref='amountmax'>
            {'$' + this.state.amounts[this.state.amounts.length - 1]}
          </span>
        </div>
        <div className='slider-label'>
          Weekly Term
        </div>
        <div className='calculator-weeks'>
          {this.state.weeks.map((week, i) => {
            return (
              <div
                key={i}
                onClick={this.weeksSelect.bind(this, i)}
                className={`${week ? '' : 'disabled'} ${this.state.weeksValue === i ? 'selected' : ''}`}>
                {week}
              </div>
              )
          })}
        </div>
        <div className='select-wrap'>
          <select ref='total' onChange={this.totalSelect.bind(this)}>
            {this.state.totals.map((option, i) => {
              return (
                <option key={i} value={i}>
                  ${option.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </option>
                )
            })}
          </select>
        </div>
        <a href=''>See examples of what could be included</a>
        <span>Your saving is {this.state.saving} ***</span>
        {this.props.showButton !== false && (
          <div>
            <button
              className='postcode-submit'
              onClick={this.start.bind(this)}>
              {this.props.button || 'START'}
            </button>
            <div>No lockin contracts</div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/calculator.js